/***
 *
 *   SCREENING ROW HELPERS
 *   Pure display logic for manual screening rows: verification rows created by
 *   "Screen a name" on /direct-verification, whose type is "sanctions",
 *   "adverse_media" or "sanctions+adverse_media". They have no Veriff session,
 *   so result_info is null and the subject's name lives on first_name /
 *   last_name instead.
 *
 *   Client mirror of helper/screening.js isScreeningOnly. The client cannot
 *   import from outside client/src, so the rule is restated here.
 *
 **********/

const SCREENING_CHECKS = ["sanctions", "adverse_media"];

/**
 * True when every "+" token of `type` is a screening check. Whole tokens only,
 * so "sanctions_monitoring" and "kyc+sanctions" are not screening rows, and an
 * empty token ("" or "sanctions+") fails.
 */
export function isScreeningRow(type) {
  if (typeof type !== "string") return false;
  return type.split("+").every((token) => SCREENING_CHECKS.includes(token));
}

// "YYYY-MM-DD" → "dd/mm/yyyy". The server validates the DOB before storing it,
// so anything else is shown as stored rather than hidden.
function formatDob(iso) {
  if (typeof iso !== "string" || iso === "") return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : iso;
}

/**
 * "Screened: {first_name} {last_name}", and with `withDob` the DOB the
 * PEP/Sanctions search was narrowed by: " · DOB dd/mm/yyyy", or
 * " · DOB not provided" when none was entered.
 */
export function formatScreenedHeader(row, options) {
  const withDob = options?.withDob === true;
  const name = `${row?.first_name || ""} ${row?.last_name || ""}`.trim();
  const header = `Screened: ${name}`;
  if (!withDob) return header;

  const dob = formatDob(row?.sanctions_results?.dob);
  return `${header} · DOB ${dob || "not provided"}`;
}
